export default __webpack_public_path__ + "static/media/GuessJobs1_17.8faa8ba5.png";